import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AccountSuccessCodes } from '@app/translations';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import {
  ActionButtonOutcomesType,
  MaturityDecision,
  MaturityDecisionRequest,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { catchError, take, tap } from 'rxjs';
import { SavingsAccountService } from '../../../services/savings-account-service/savings-account.service';
import { SavingsAccountState } from '../../../state/savings-account.state';
import { findAndShowAlertFromCode } from '../../alert-code-utils/alert-code.utils';
import { handleRedirection } from '../cta-redirection.utils';

export function submitMaturityDecisionWithdraw(injector: Injector, attri: UiZoneWidgetAttributeConfig) {
  const store = injector.get(Store);
  const alertHandlerService = injector.get(AlertHandlerService);
  const activeAccount = store.selectSnapshot(SavingsAccountState.getCurrentAccount);

  if (!activeAccount) {
    alertHandlerService.showAlertFn('error', 'No active account found');
    return;
  }

  const savingsAccountService = injector.get(SavingsAccountService);
  const router = injector.get(Router);
  const actionButtonNavigationConfigurations = attri.widgetProperties?.actionNavigationConfigurations;

  const payload: MaturityDecisionRequest = {
    decision: MaturityDecision.WITHDRAW,
  };

  savingsAccountService
    .submitMaturityDecision(payload, activeAccount.accountId)
    .pipe(
      tap(() => {
        findAndShowAlertFromCode(store, router, alertHandlerService, [
          AccountSuccessCodes.MATURITY_DECISION_SUCCESS,
        ]);
        if (actionButtonNavigationConfigurations?.success) {
          handleRedirection(attri.widgetProperties, injector, ActionButtonOutcomesType.SUCCESS, true);
        }
      }),
      catchError((err) => {
        if (actionButtonNavigationConfigurations?.failure) {
          handleRedirection(attri.widgetProperties, injector, ActionButtonOutcomesType.FAILURE, true);
        }
        throw err;
      }),
      take(1),
    )
    .subscribe();
}
